import React, { useLayoutEffect, useState } from 'react'
import Text from '../../atoms/Text/Text'
import styled from 'styled-components'
import media from 'styled-media-query'
import linkedinLogo from '../../../images/linkedinLogo.svg'
import ReviewedCheck from '../../../images/reviewed_check'
import shield from '../../../images/shield.svg'
import cash from '../../../images/cashgreen.svg'
import down from '../../../images/downpath.svg'
import IconInfo from '../../IconInfo/IconInfo'
import { removeTags } from '../../../utils/removeTags'

const Style = styled.div`
  .cards-button-text {
    background: white;
    font-weight: ${(prop) => (prop.profile ? '400' : '500')};
    z-index: 10;
    color: #4d657f;
    display: flex;
    align-items: center;
  }
  .down {
    height: 5px;
    width: 8px;
    margin-left: 6px;
  }
  .shield {
    height: 16px;
    width: 16px;
    margin-right: 8px;
  }
  display: inline-block;
  .tooltip {
    position: ${(prop) => (prop.cursor ? '' : 'relative')};
    display: inline-block;
  }

  .claimed-status {
    display: inline-block;
    color: #d6d6d6;
  }
  .body-text {
    text-align: left;
    border-width: 10px;
    border-style: solid;
    border-color: #fff transparent transparent transparent;
    word-wrap: break-word;
    width: 100%;
    p {
      font-size: 16px !important;
      line-height: 18px;
    }
  }

  .header-text {
    font-weight: 600;
    font-size: 16px;
    text-align: left;
    margin: 5px 10px;
  }
  .ft-text {
    padding: 5px 0 10px 10px;
    text-align: left;
    p {
      font-size: 16px !important;
    }
  }
  .fr-link {
    text-decoration: none;
    // color: #0000ee;
  }

  .author-tooltip-trigger {
    text-align: left;
  }
  .author-tooltip {
    padding: 10px;
  }
  .author-button-text {
    cursor: pointer;
    margin: 0;
    color: #31279b;
    font-weight: 600;
    text-decoration: none;
  }
  .author-tooltip-title {
    cursor: pointer;
    font-size: 18px;
    color: #31279b;
    font-weight: 600;
    text-decoration: none;
  }
  .tooltip-title {
    text-align: left !important;
    display: block !important;

    font-weight: 600;
    text-decoration: none;
    margin-left: 10px !important;
    margin-top: 10px;
    font-size: 16px !important;
  }

  .author-tooltip-subtitle {
    margin: 0 0 20px 0;
    color: #6d6d6d;
    font-size: 16px;
  }

  .author-body-text {
    text-align: left;
  }

  .reviewer-tooltip-subtitle {
    color: #6d6d6d;
    font-size: 12px;
    color: #6d6d6d;
    text-align: left;
    text-indent: -4px;
    margin-bottom: 12px;
    margin-top: 10px;
  }
  .tooltip {
    position: relative;
    display: inline-flex;
  }
  .tooltiptext {
    cursor: default;
  }
  .tooltip .tooltiptext {
    ${media.greaterThan('medium')`
    margin:1px;
    `}
    transition-delay: 0.5s;
    background-color: #ffffff;
    color: #000000;
    visibility: hidden;
    width: ${(prop) => (prop.wide ? '400px' : '220px')};
    text-align: center;
    border-radius: 6px;
    position: fixed;
    top: 120px;
    left: 0px;
    visibility: hidden;
    max-width: ${(prop) => (prop.wide ? '400px' : '250px')};
    top: 23px;

    /* Position the tooltip */
    position: absolute;
    z-index: 1001;
  }

  /* Tooltip arrow */
  .tooltip .tooltiptext::after {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 19%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #ffffff transparent;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
    top: 23px;
    box-shadow: rgba(0, 0, 0, 0.3) 0 2px 10px;
  }
  .card-button-text {
    background: white;
  }
`
const Tooltip = (props) => {
  return (
    <Style
      cursor={props.cursor}
      wide={props.wide}
      profile={props.profile}
    >
      {!props.blog && (
        <div
          id={props?.id}
          className="tooltip desktop"
          style={props.cards ? { marginBottom: '0', display: 'flex' } : {}}
        >
          {props.treatmentButton && (
            <Text
              className="treatment-button-text"
              style={{
                borderBottom: props.borderBottom,
                fontSize: '16px'
              }}
            >
              {props.tooltipTitle}
            </Text>
          )}
          {props.adDisclaimer && (
            <div className="flex items-center gap-1 text-sm text-gray-900">
              <div>Ads</div>
              <div>
                <IconInfo size="sm" />
              </div>
            </div>
          )}
          {props.cards && (
            <p
              className={`cards-button-text ${
                props.profile ? 'cursor-pointer text-base' : 'text-xs'
              }`}
            >
              <img
                src={props.cash ? cash : shield}
                className="shield"
              />
              {props.triggerText}
              <img
                src={down}
                className="down"
              />
            </p>
          )}
          {!props.cards && props.triggerImage && (
            <img
              src={props.triggerImage}
              className="mx-[5px] my-auto align-top text-gray-900"
            />
          )}
          {props.triggerText && props.triggerImage && (
            <Text
              style={{
                display: 'inline-block',
                color:
                  props.triggerText === 'Claimed'
                    ? '#677d95'
                    : props.triggerText === 'Unclaimed'
                    ? '#677D95'
                    : '#38A0DB',
                fontWeight: '600',
                fontSize: '14px'
              }}
              className="claimed-status-text cursor-pointer"
            >
              <span>{props.triggerText}</span>
            </Text>
          )}
          <span className="tooltiptext">
            <p className="tooltip-title text-base">{props.tooltipTitle}</p>
            <p className="text-base text-[#6D6D6D]">{props.tooltipSubtitle}</p>
            {props.treatmentTitle && (
              <div className="header-text">
                <p>{props.treatmentTitle}</p>
              </div>
            )}
            {props.showListings ? (
              <div className="m-2 inline-block break-words border-x-2 border-b-0 border-t-2 border-white text-left text-base leading-[18px]">
                <p className="w-full cursor-default break-words">
                  {removeTags(props.tooltipBodyText).trim()}
                  {props.footerLinkText && props.footerLink && (
                    <span>
                      {'..'}
                      <a
                        href={`${props.footerLink}`}
                        className="font-semibold no-underline hover:cursor-pointer hover:underline"
                      >
                        {props.footerLinkText}
                      </a>
                    </span>
                  )}
                </p>
              </div>
            ) : (
              <div className="body-text">
                <span
                  dangerouslySetInnerHTML={{ __html: props.tooltipBodyText }}
                  className="w-full break-words"
                ></span>
                {props.footerLink && (
                  <div className="pt-2">
                    <p
                      className={`${
                        props.adDisclaimer
                          ? 'text-black underline'
                          : 'font-semibold text-[#0000ee] hover:underline'
                      } cursor-pointer text-sm`}
                      onClick={() => {
                        typeof location !== 'undefined' && !props.profile
                          ? window.open(`${props.footerLink}`, '_blank')
                          : (window.location.href = `${props.footerLink}`)
                      }}
                    >
                      {props.footerLinkText}
                    </p>
                  </div>
                )}
              </div>
            )}

            {props.showListings && props.centerTipLink && (
              <div className="center-link m-2 border-b-2 border-white font-semibold text-[#0000ee]">
                <p
                  className="center-link-text text-left hover:cursor-pointer hover:underline"
                  onClick={() => {
                    window.open(`${props.centerTipLink}`, '_blank')
                  }}
                >
                  {props.centerTipLinkText}
                </p>
              </div>
            )}
          </span>
        </div>
      )}

      {props.blog && props.isAuthor && (
        <div className="tooltip desktop author-tooltip-trigger">
          {props.authorName && (
            <span className="author-button-text cursor-pointer">
              {props.authorName}
            </span>
          )}
          <span className="tooltiptext author-tooltip">
            <span className="author-tooltip-title">{props.tooltipTitle}</span>
            <p className="author-tooltip-subtitle">{props.tooltipSubtitle}</p>
            <div style={{ width: '20px' }}>
              {props.authorLinkedin && (
                <a
                  href={props.authorLinkedin}
                  target="_blank"
                  referrerPolicy="no-referrer"
                >
                  <img
                    style={{
                      display: 'inline-block',
                      filter:
                        'invert(48%) sepia(5%) saturate(1644%) hue-rotate(140deg) brightness(90%) contrast(96%)'
                    }}
                    src={linkedinLogo}
                    alt=""
                  />
                </a>
              )}
            </div>
            <div
              className="author-body-text"
              dangerouslySetInnerHTML={{ __html: props.tooltipBodyText }}
            />
          </span>
        </div>
      )}
      {props.blog && props.isReviewer && (
        <div className="tooltip desktop author-tooltip-trigger">
          {props.reviewerName && (
            <span className="author-button-text">{props.reviewerName}</span>
          )}
          <span className="tooltiptext author-tooltip">
            <div style={{ display: 'flex' }}>
              <div style={{ width: '75px' }}>
                <img
                  src={`https://res.cloudinary.com/rehabpath/image/upload/v1655327781/${props.reviewerSlug}-circular-headshot.jpg`}
                  alt=""
                  style={{
                    borderRadius: '50%',
                    width: '100%'
                  }}
                />
              </div>
              &nbsp;
              <div style={{ marginLeft: '10px', float: 'right' }}>
                <p className="reviewer-tooltip-subtitle">
                  <ReviewedCheck style={{ color: '#E55925' }} />
                  &nbsp;
                  {props.tooltipSubtitle}
                </p>
              </div>
            </div>
            <div style={{ margin: '15px 0 0 0', width: '20px' }}>
              {props.reviewerLinkedin && (
                <a
                  href={props.reviewerLinkedin}
                  target="_blank"
                  referrerPolicy="no-referrer"
                >
                  <img
                    style={{
                      display: 'inline-block',
                      filter:
                        'invert(48%) sepia(5%) saturate(1644%) hue-rotate(140deg) brightness(90%) contrast(96%)'
                    }}
                    src={linkedinLogo}
                    alt=""
                  />
                </a>
              )}
            </div>
            <div
              className="author-body-text"
              dangerouslySetInnerHTML={{ __html: props.tooltipBodyText }}
            />
          </span>
        </div>
      )}
    </Style>
  )
}

export default Tooltip
